import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { snakeCaseToCamelCase } from "./snakeCaseToCamelCase";
export function camelizeProperties(obj) {
  if (obj && _typeof(obj) === 'object') {
    return Object.keys(obj).reduce(function (acc, key) {
      var newKey = key;
      if (typeof key === 'string') {
        newKey = snakeCaseToCamelCase(key);
      }
      //@ts-expect-error ToDo: fix this
      acc[newKey] = obj[key];
      return acc;
    }, {});
  }
  return obj;
}

/**
 * Accepts any object type & attempts to convert all snake case properties to camel case.
 * This includes all nested properties.
 *
 * @param obj
 * @returns object with all properties (top level or  in any waynested) as camel case
 */
export function camelizeAllProperties(obj) {
  if (obj === null || obj === undefined) return obj;
  if (Array.isArray(obj)) {
    return obj.map(function (element) {
      return camelizeAllProperties(element);
    });
  }
  if (_typeof(obj) === 'object') {
    return Object.keys(obj).reduce(function (acc, key) {
      var newKey = key;
      if (typeof key === 'string') {
        newKey = snakeCaseToCamelCase(key);
      }
      //@ts-expect-error ToDo: fix this
      acc[newKey] = camelizeAllProperties(obj[key]);
      return acc;
    }, {});
  }
  return obj;
}